import { Platform, TextStyle } from 'react-native';

type ConfigType = {
  theme: {
    headingFontSize: number;
    headingFontWeight: TextStyle['fontWeight'];
    headingEndMargin: number;
    headingTextColor: string;
    brandColor: string;
    carousel: {
      imageBorder: number;
      imageBorderColor: string;
      cardBorderColor: string;
      cardBorderWidth: number;
    };
    advert: {
      headingTextColor: string;
      subSectionHeadingTextColor: string;
      imageHeight: number;
      imageHeightRatio: number;
    };
    list: {
      marginBottom: number;
    };
  };
  advertTracking: {
    carousel: {
      minimumViewTime: number;
      viewAreaCoveragePercentThreshold: number;
    };
  };
};

const baseTextColor = '#303030';

const config: ConfigType = {
  theme: {
    headingFontSize: 20,
    headingFontWeight: '700',
    headingEndMargin: 15,
    headingTextColor: baseTextColor,
    brandColor: '#d83938',
    carousel: {
      imageBorder: 1,
      imageBorderColor: '#e0e0e3',
      cardBorderColor: '#f0f0f0',
      cardBorderWidth: 50,
    },
    advert: {
      headingTextColor: baseTextColor,
      subSectionHeadingTextColor: '#707070',
      imageHeight: 120,
      imageHeightRatio: 0.637254901961,
    },
    list: {
      marginBottom: Platform.OS === 'android' ? 100 : 0,
    },
  },
  advertTracking: {
    carousel: {
      minimumViewTime: 250,
      viewAreaCoveragePercentThreshold: 50,
    },
  },
};

export default config;
